module.exports = __webpack_public_path__ + "img/TK.d05d9be1.png";